import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import {BUSCAR_PRECOS_ROTA} from '../types';

export default (empresaId, rotaId, tipoPrecos = []) => {
  let url_precos; 
  if (tipoPrecos && tipoPrecos.length > 0) {
    url_precos = `${URL}/preco/empresa/${empresaId}/rota/${rotaId}?tipoPrecos=${''.concat(tipoPrecos)}`
  } else {
    url_precos = `${URL}/preco/empresa/${empresaId}/rota/${rotaId}`
  }

  return dispatch => axios.get(url_precos,SLOW_REQUEST_CONFIG)
    .then(response => dispatch({
      type: BUSCAR_PRECOS_ROTA,
      payload: response
    }));
}

